/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 16,
  image: "",
  title: "Changelog Notes - V3.2.1-beta",
  shortDescription: "We have introduced the Optimism chain for subscription payments. We have allowed four tokens - USDT, USDC, DAI, and WETH on the Optimism chain. All the user flow for upgrading to the PRO plan using Optimism is the same, but you can connect your metamask wallet and select the Optimism chain to upgrade to pro and buy bonuses.",
  description: "We have introduced the Optimism chain for subscription payments. We have allowed four tokens - USDT, USDC, DAI, and WETH on the Optimism chain. All the user flow for upgrading to the PRO plan using Optimism is the same, but you can connect your metamask wallet and select the Optimism chain to upgrade to pro and buy bonuses.",
  date: "Nov 17th, 2022",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Optimism", "subscription", "tokens", "improvement", "bug", "fixes"]
};
export const content = ` 
## Optimism Integration

<div className="image-box-shadow">
  <img
    src="/changelog/v3.2.1/header.png"
    alt="Image"
    className="rounded-[12px]"
  />
</div>

We have introduced the **Optimism** chain for subscription payments. We have allowed four tokens - **USDT, USDC, DAI,** and **WETH** on the **Optimism** chain. All the user flow for upgrading to the PRO plan using **Optimism** is the same, but you can connect your metamask wallet and select the **Optimism** chain to upgrade to pro and buy bonuses.

## UX improvements

- **Repository filtering:** we have added support to filter and search your repositories directly from the server in Github, Gitlab & Bitbucket. This will provide better UX for users to search their repository without loading it in the UI first.

## Fixes 🛠

- We have fixed the issue that would cause an organization not to have an active subscription.
- We have fixed a couple of bugs on our CDN.
- We have fixed the issue that didn’t allow the cluster environment variables to have = character.
- We have fixed the issue that was causing the arweave deployment to fail on our Upload-API.
- We have fixed the issue causing the subscription usage not to update when deleting ENS and HNS domains.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
